<tec-dashboard-layout>
    <ng-container dashboard>
        @if (balanceStatus !== 'ok'){
            <app-operation-balance-alert [balanceStatus]="balanceStatus" />
        }

        <div class="item-group">
            <tec-toolbar #datesToolbar [toolbar]="toolbar()" (formFilter)="filterChange($event)" />

            <app-stats />

            <div class="layout--60-40">
                <app-process-chart />
                <app-panel-insights />
            </div>
        </div>

        <div class="item-group">
            <app-manual-validation-processes />
            <app-in-progress-processes />
        </div>

        <app-navigation-cards />
    </ng-container>
</tec-dashboard-layout>
